const defaultState = () => ({
  shareView: false,
  previewScreenView: false,

});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    reset(state) {
      Object.assign(state, defaultState());
    },
    openPreviewScreen(state) {
      state.previewScreenView = true;
    },
    toggleShareView(state) {
      state.shareView = !state.shareView;
    },
    togglePreviewScreenView(state) {
      state.previewScreenView = !state.previewScreenView;
    },
    showShareView(state) {
      state.previewScreenView = false;
      state.shareView = true;
    },
    closeBothScreens(state) {
      state.previewScreenView = false;
      state.shareView = false;
    },
    closeShareView(state) {
      state.shareView = false;
      state.previewScreenView = true;
    },
  },
  actions: {
    async togglePreviewScreenView({ commit, state }) {
      commit('togglePreviewScreenView');
      document.body.style.overflow = state.previewScreenView ? 'hidden' : 'visible';
    },
    async toggleShareView({ commit, state }) {
      commit('toggleShareView');
      document.body.style.overflow = state.shareView ? 'hidden' : 'visible';
    },
  },
  getters: {
    shareView: state => state.shareView,
    previewScreenView: state => state.previewScreenView,
  },
};
